import React, { useState, useMemo, useEffect } from 'react'
import '../views/ItemOptionsModal.css'
import SAUCES from '../utils/sauces'
import VIANDES_MITRAILLETTES from '../utils/viandes'
import BURGERS from '../utils/burgers'

const SUPPLEMENTS = [
  { name: 'Frites', price: 2.00 },
  { name: 'Crudité simple', price: 0.70 },
  { name: 'Fromage Cheddar', price: 0.5 },
  { name: 'Oignons secs', price: 0.5 },
  { name: 'Concombre Bicky rondelles', price: 0.5 },
  { name: 'Feta', price: 1.5 },
  { name: 'Bacon', price: 1.0 },
]

const ItemOptionsModal = ({
  item,
  showSauce,
  showSupplements,
  showViande,
  showBrochette,
  sauces: saucesProp,
  viandes: viandesProp,
  brochettes: brochettesOptions = [],
  onConfirm,
  onClose
}) => {
  const saucesOptions = saucesProp || SAUCES
  const viandesOptions = viandesProp || VIANDES_MITRAILLETTES
  const [sauceFrites, setSauceFrites] = useState('')
  const [sauceBurger, setSauceBurger] = useState('')
  const isBoxEnfant = item?.name === "Box Enfant"

  // STATE
  const [sauce, setSauce] = useState('')
  const [supplements, setSupplements] = useState([])
  const [viande, setViande] = useState('')
  const [burger, setBurger] = useState('')
  const [choiceType, setChoiceType] = useState('')
  const selectedSauce = isBoxEnfant
  ? {
      frites: sauceFrites,
      burger: choiceType === 'burger' ? sauceBurger : null
    }
  : sauce
  const [brochette1, setBrochette1] = useState('')
  const [brochette2, setBrochette2] = useState('')

  const clean = (str) =>
    str?.toString().replaceAll('"', '').trim()
  const normalize = (str) =>
    str?.toString().replaceAll('"', '').trim()
  const toggleSupplement = (sup) => {
    setSupplements((prev) =>
      prev.find((s) => s.name === sup.name)
        ? prev.filter((s) => s.name !== sup.name)
        : [...prev, sup]
    )
  }
  const parsePrice = (value) => {
    if (!value) return 0

    return parseFloat(
      String(value)
        .replace('€', '')
        .replace(',', '.')
        .trim()
    ) || 0
  }
  const totalPrice = useMemo(() => {
    let total = parsePrice(item?.price)

    // 🍔 BOX ENFANT / BURGER
    if (isBoxEnfant && choiceType === 'burger' && burger) {
      total += parsePrice(burger.price)
    }

    // 🥩 VIANDE
    if (viande) {
      total += parsePrice(viande.price)
    }

    // 🍢 BROCHETTES (IMPORTANT: ajout réel)
    if (showBrochette) {
      const b1 = brochettesOptions.find(b => b.name === brochette1)
      const b2 = brochettesOptions.find(b => b.name === brochette2)

      total += parsePrice(b1?.price)
      total += parsePrice(b2?.price)
    }

    // 🥗 SUPPLÉMENTS (UNIQUEMENT BURGER / BOX BURGER)
    const allowSupplements =
      (isBoxEnfant && choiceType === 'burger' && burger) ||
      (!isBoxEnfant && item?.name?.toLowerCase().includes('burger')) ||
      showViande

    if (allowSupplements) {
      supplements.forEach(s => {
        total += parsePrice(s.price)
      })
    }

    return total
  }, [
    item,
    isBoxEnfant,
    choiceType,
    burger,
    viande,
    brochette1,
    brochette2,
    supplements,
    showBrochette,
    brochettesOptions
  ])
  useEffect(() => {
    if (!isBoxEnfant) return

    if (choiceType === 'viande') {
      setBurger(null)
      setSupplements([])
    }

    if (choiceType === 'burger') {
      setViande(null)
    }
  }, [choiceType, isBoxEnfant])
  const buildBoxLabel = () => {
    let label = item.name

    if (choiceType === 'burger') {
      const selectedBurger = BURGERS.find(b => b.name === burger)
      if (selectedBurger) {
        label += ` + ${selectedBurger.name}`
      }
    }

    if (choiceType === 'viande') {
      const selectedViande = viandesOptions.find(v => v.name === viande)
      if (selectedViande) {
        label += ` + ${selectedViande.name}`
      }
    }

    return label
  }

  const handleConfirm = () => {

    const selectedViande = viande
      ? viandesOptions.find(v => v.name === viande) || null
      : null

    const selectedBurger = burger
      ? BURGERS.find(b => b.name === burger) || null
      : null

    let selectedBrochettes = null
    if (showBrochette) {
      selectedBrochettes = [
        brochette1 ? brochettesOptions.find(b => b.name === brochette1) || null : null,
        brochette2 ? brochettesOptions.find(b => b.name === brochette2) || null : null,
      ]
    }

    const boxEnfantLabel = isBoxEnfant ? buildBoxLabel() : item.name

    onConfirm(
        selectedSauce,
      supplements,
      viande,
      selectedBrochettes,
      choiceType,
      burger,
      isBoxEnfant
        ? {
          type: choiceType,
          burger: selectedBurger,
          label: boxEnfantLabel
        }
        : null
    )
  }

  return (
    <div
      className="modal-overlay"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="modal-box">

        <button className="modal-close" onClick={onClose}>×</button>

        <h3 className="modal-title">{item.name}</h3>
        <p className="modal-item-price">{item.price}</p>

        {/* SAUCE */}
        {showSauce && !isBoxEnfant && (
          <div className="modal-section">
            <h4>Sauce</h4>
            <select value={selectedSauce} onChange={(e) => setSauce(e.target.value)}>
              <option value="">— Sans sauce —</option>
              {saucesOptions.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </div>
        )}

        {/* BOX ENFANT */}
        {isBoxEnfant && (
          <div className="modal-section">
            <h4>Choix menu enfant</h4>

            <label>
              <input
                type="radio"
                checked={choiceType === 'burger'}
                onChange={() => setChoiceType('burger')}
              />
              Burger
            </label>

            <label style={{ marginLeft: 15 }}>
              <input
                type="radio"
                checked={choiceType === 'viande'}
                onChange={() => setChoiceType('viande')}
              />
              Viande
            </label>
          </div>
        )}
        {isBoxEnfant && (
          <div className="modal-section">
            <h4>Sauce pour les frites</h4>

            <select
              value={sauceFrites}
              onChange={(e) => setSauceFrites(e.target.value)}
            >
              <option value="">— Sans sauce —</option>

              {saucesOptions.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* BURGER */}
        {isBoxEnfant && choiceType === 'burger' && (
          <div className="modal-section">
            <h4>Burger au choix</h4>

            <select
              value={burger?.name || ''}
              onChange={(e) => {
                const selected = BURGERS.find(
                  (b) => b.name === e.target.value
                )
                setBurger(selected || null)
              }}
            >
              <option value="">— Choisissez un burger —</option>

              {BURGERS.map((b) => (
                <option key={b.name} value={b.name}>
                  {b.name} (+{b.price.toFixed(2).replace('.', ',')}€)
                </option>
              ))}
            </select>
          </div>
        )}
        {isBoxEnfant && choiceType === 'burger' && burger && (
          <div className="modal-section">
            <h4>Sauce du burger</h4>

            <select
              value={sauceBurger}
              onChange={(e) => setSauceBurger(e.target.value)}
            >
              <option value="">— Sans sauce —</option>

              {saucesOptions.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>
        )}
        {/* VIANDE */}
        {showViande && (!isBoxEnfant || choiceType === 'viande') && (
          <div className="modal-section">
            <h4>Viande au choix</h4>

            <select
              className="Select_viande"
              value={viande?.name || ''}
              onChange={(e) => {
                const selected = viandesOptions.find(
                  (v) => v.name === e.target.value
                )
                setViande(selected || null)
              }}
            >
              <option value="">— Choisissez votre viande —</option>

              {viandesOptions.map((v) => (
                <option key={v.name} value={v.name}>
                  {v.name} (+{Number(v.price).toFixed(2).replace('.', ',')}€)
                </option>
              ))}
            </select>
          </div>
        )}
        {showBrochette && (
          <div className="modal-section">
            <h4>Première brochette</h4>

            <select
              value={brochette1}
              onChange={(e) => setBrochette1(e.target.value)}
            >
              <option value="">— Choisissez une brochette —</option>

              {brochettesOptions.map((b) => (
                <option key={b.name} value={b.name}>
                  {b.name} (+{Number(b.price).toFixed(2).replace('.', ',')}€)
                </option>
              ))}
            </select>

            <h4 style={{ marginTop: 15 }}>Deuxième brochette</h4>

            <select
              value={brochette2}
              onChange={(e) => setBrochette2(e.target.value)}
            >
              <option value="">— Choisissez une brochette —</option>

              {brochettesOptions.map((b) => (
                <option key={b.name} value={b.name}>
                  {b.name} (+{Number(b.price).toFixed(2).replace('.', ',')}€)
                </option>
              ))}
            </select>
          </div>
        )}
        {/* SUPPLEMENTS */}
        {(
          (isBoxEnfant && choiceType === 'burger' && burger) ||
          (!isBoxEnfant && item?.name?.toLowerCase().includes('burger')) ||
          showViande
        ) && (
            <div className="modal-section">
              <h4>Suppléments aux choix</h4>

              <ul className="modal-supplements-list">
                {SUPPLEMENTS.map((sup) => {
                  const checked = !!supplements.find((s) => s.name === sup.name)

                  return (
                    <li key={sup.name}>
                      <label>
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => toggleSupplement(sup)}
                        />
                        {sup.name} (+{sup.price.toFixed(2).replace('.', ',')}€)
                      </label>
                    </li>
                  )
                })}
              </ul>
            </div>
          )}
        <div className="modal-total">
          <strong>Total : {totalPrice.toFixed(2).replace('.', ',')}€</strong>
        </div>
        {/* ACTIONS */}
        <div className="modal-actions">
          <button onClick={onClose}>Annuler</button>
          <button onClick={handleConfirm}>Ajouter au panier</button>
        </div>

      </div>
    </div>
  )
}

export default ItemOptionsModal